import React from 'react';
import PropTypes from 'prop-types';
import {
  FDDialog, FDDialogActions, FDDialogTitle, FDDialogContent, FDPrimaryActionButton, FDTextButton, FDBox,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import { DataValueMap } from 'Helpers/Testing';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import DataContainer from 'Components/UI/DataContainer';
import {
  usePlannerTransition,
} from 'Components/AdvisorApp/Viewport/Users/PlannerTransitionDialog/usePlannerTransition';
import {
  PlannerTransitionOverride,
} from 'Components/AdvisorApp/Viewport/Users/PlannerTransitionDialog/PlannerTransitionOverride';
import Relationship from 'facet-rest/src/domain/Relationship';

const PlannerTransitionDialog = ({
  open,
  onClose,
  plannerTransitionRelationship,
}) => {
  const {
    loading,
    loadingError,
    submitting,
    submitError,
    plannerTransitionResource,
    submitPlannerTransition,
    loadPlannerTransition,
  } = usePlannerTransition(plannerTransitionRelationship, onClose);

  const submitDisabled = !plannerTransitionResource || !plannerTransitionResource.meta().canSubmit();

  return (
    <FDDialog open={open} onClose={onClose} {...DataValueMap.init('transition-planner-dialog').build()}>
      <FDDialogTitle value={'Transition Planner'} />
      <FDDialogContent>
        <FDBox width={'500px'}>
          <DataContainer
            loading={loading}
            loadingError={loadingError}
            component={() => (
              <MetaFormInline
                noIndividualSubmitButtons
                metaOverrideSet={PlannerTransitionOverride}
                resource={plannerTransitionResource}
                errorsOverride={submitError}
              />
            )}
          />
        </FDBox>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Submit'}
          onClick={async () => {
            await submitPlannerTransition();
            await loadPlannerTransition();
          }}
          loading={submitting}
          disabled={submitDisabled}
        />
        <FDTextButton
          label={'Close'}
          onClick={() => onClose()}
          loading={submitting}
        />
      </FDDialogActions>
    </FDDialog>
  );
};

PlannerTransitionDialog.defaultProps = {
  onClose: noop,
};

PlannerTransitionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  plannerTransitionRelationship: PropTypes.instanceOf(Relationship).isRequired,
};

export { PlannerTransitionDialog };
